module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/209-indonesia-f3f965fb264451e18d0bad8d1b28dc76.svg";